import { copyToClipboard } from '@common/utils'
import { TrustpilotRating } from '@components/common/icons/custom-icons'
import { FastlyImage } from '@components/common/image'
import {
  CODING_SUMMER_CAMP_DETAILS,
  CODING_SUMMER_CAMP_HIGHLIGHT,
} from '@lib/data/summer-coding-camp'
import { Trans } from '@lingui/macro'
import { useEffect, useState } from 'react'
import { CreditCard } from 'react-feather'

type CodingSummerCampProps = {
  title: JSX.Element
  description: JSX.Element
  couponCode: string
  coursePrice: number
  discountedPrice: number
  offerPercentage: number
  imagePath: string
  imageAlt: string
  backgroundColour: string
}

const FirstFold = ({
  title,
  description,
  couponCode,
  coursePrice,
  discountedPrice,
  offerPercentage,
  imagePath,
  imageAlt,
  backgroundColour,
}: CodingSummerCampProps) => {
  const [isCopied, setIsCopied] = useState(false)

  const handleCopyCouponCode = () => {
    copyToClipboard(couponCode)
    setIsCopied(true)
  }

  useEffect(() => {
    setTimeout(() => {
      setIsCopied(false)
    }, 3000)
  }, [isCopied])

  return (
    <>
      <div
        className="relative overflow-hidden z-0 pb-20"
        style={{
          background: backgroundColour,
        }}
      >
        <div className="container mx-auto relative max-w-6xl text-white px-2 pt-8 space-y-3">
          <h1 className="font-700 text-2xl lg:text-5xl leading-tight z-10 text-center lg:text-left">
            {title}
          </h1>
          <div className="gap-2 flex flex-wrap justify-center lg:justify-start">
            {CODING_SUMMER_CAMP_HIGHLIGHT.map((highlight) => (
              <span
                key={highlight}
                className="inline-block px-4 rounded-md text-left text-grey"
                style={{
                  background: '#E0E3FD',
                }}
              >
                {highlight}{' '}
              </span>
            ))}
          </div>
          {description}

          <div className="flex space-x-2 items-center flex-col lg:flex-row pt-2 mx-3 md:mx-0">
            <a
              className="text-center btn btn-orange w-full md:w-auto py-3 text-lg"
              href="#courses"
            >
              Claim your spot now
            </a>
            <p className="font-600 py-2">Few slots remaining, hurry now!</p>
          </div>
          <div>
            <div className="flex md:space-x-4 items-center pt-1 justify-center lg:justify-start flex-col md:flex-row">
              <div className="flex space-x-2 items-center justify-center lg:justify-start">
                <CreditCard className="text-white w-5" />
                <p className="text-2xl lg:text-3xl line-through">
                  ${coursePrice}
                </p>
                <p className="text-xl lg:text-2xl font-600 pl-3">
                  ${discountedPrice}
                </p>
                <p
                  className="inline-block px-4 rounded-md text-left text-grey"
                  style={{
                    background: '#FFDB6B',
                  }}
                >
                  {offerPercentage}% Off
                </p>
              </div>
              <div className="py-2 md:py-0">
                {isCopied ? (
                  <p className="text-sm">
                    <Trans>Coupon code copied to clipboard</Trans>
                  </p>
                ) : (
                  <>
                    <div className="flex flex-col items-center">
                      <p
                        onClick={() => handleCopyCouponCode()}
                        className="font-500 border-white border rounded pt-1 px-2 hover:text-smoke cursor-pointer"
                      >
                        {couponCode}
                      </p>
                      <span
                        className="-mt-2 px-1 text-xs block"
                        style={{ background: backgroundColour }}
                      >
                        <Trans>Coupon Code</Trans>
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="flex space-x-2 py-3 flex-col md:flex-row items-center justify-center lg:justify-start">
            {/* Trust Pilot Rating SVG  */}
            <TrustpilotRating />
            <p>
              <Trans>4.7 rating by 162 reviews on Trustpilot</Trans>
            </p>
          </div>
          <div
            className="mt-4 mx-10 hidden lg:block absolute right-0 xl:right-5"
            style={{ top: '7rem' }}
          >
            <FastlyImage
              src={`${imagePath}.png`}
              webpSrc={`${imagePath}.webp`}
              alt={imageAlt}
              width={342}
              height={308}
              loading="eager"
            />
          </div>
        </div>
      </div>
      <div className="container mx-auto relative max-w-6xl px-4 -mt-16">
        <div className="flex flex-wrap justify-center p-4 lg:py-6 items-start text-grey mb-1 text-sm">
          {CODING_SUMMER_CAMP_DETAILS.map((details, index) => (
            <>
              <div
                key={index}
                className="flex flex-col w-1/2 md:w-1/3 lg:w-40 h-24 p-2 justify-center items-center text-center"
                style={{ backgroundColor: details.backgroundColor }}
              >
                <FastlyImage
                  src={details.imagepath}
                  alt={details.title}
                  width={28}
                  height={28}
                />
                <p>{details.title}</p>
                <p className="font-600 text-lg">{details.description}</p>
              </div>
            </>
          ))}
        </div>
      </div>
    </>
  )
}
export default FirstFold
